import React from 'react';
import StudentBadgeItem from './StudentBadgeItem';
import { studentBadgeType } from '../../../constants/types/student-type';
import { getStudentBadge } from '../../../api/utils/api/studentApi';

const StudentBadgeList = () => {
  const [badgeList, setBadgeList] = React.useState<studentBadgeType[]>([]);

  React.useEffect(() => {
    getStudentBadge().then((data) => {
      setBadgeList(data);
    });
  }, []);

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-4 mt-8 justify-between gap-y-10">
        {badgeList
          .sort((a, b) => a.sort - b.sort)
          .map((item, index) => (
            <StudentBadgeItem key={index} badge={item} />
          ))}
      </div>
      {badgeList.length === 0 && (
        <div className="text-center w-full font-lg text-gray7 text-bold">
          획득한 뱃지가 없습니다.
        </div>
      )}
    </>
  );
};

export default StudentBadgeList;
